var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"py-6",attrs:{"justify":"center"}},[_c('h2',{staticClass:"justify-center"},[_c('AccountHeart'),_vm._v(" Modulo di tesseramento")],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }